
  import { Component, Vue ,Model,Watch, Prop} from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import Dialog from './dialog.vue';
	import PickerDate from '@/components/picker-date.vue';
  import {
    productCategory,
    productList,
    productpopoverproductlist
  } from '@/api/supplier'
	import {
    getSearchDate,
		nextDay
	} from "@/utils"
  @Component({  
    name: '',
    components: {
      PageFooter,
      'slz-dialog': Dialog,
      PickerDate,
    }
  })

  export default class ProductList extends Vue {
    @Model('change') show!:boolean
    @Prop({default:[]}) data!:any
    @Prop({default:200}) maxchoose!:number//最多选择数量 0表示无限
    @Prop({default:0}) ProductScheduleState!:number// 0:已排期 1:已结束
    @Prop({default:null}) ProductType!:any
    @Prop({default:null}) IsExchangeBuyProduct!:boolean//2024-6-5产品说其他地方换购品可以被选
    private dialogshow = false
    private defaultThumb = 'https://cdn2024.routuan.com/routuanapp/default-thumb.png';
    private keywords = ''
    private filterTime = [getSearchDate(2,false,-7)[0],getSearchDate(2,false,7)[0]].join('/')
    private classify = ''
    private classifylist:any = []
    private tablelist:any = []
    private tableloading = false
    private pageSize = 10
    private pageNo = 1
    private total = 0
    private chooselist:any = []
    private isfirst = true
    private title = '选择商品'
    private subhead = ''
    @Watch('show')
    private getshow(e){
      this.isfirst = e
      // console.log(this.isfirst)
      this.chooselist = this.data
      this.dialogshow = this.show
      this.init()
      this.getclassifylist()
      this.gettablelist()
    }

    private mounted () {
      this.isfirst = true
      this.chooselist = this.data
      this.init()
    }

    private init(){
      if(this.IsExchangeBuyProduct){
        this.title = '选择换购商品'
        this.subhead = '当前页面只显示换购商品，最多选择999件换购商品，未上架的商品不会展示在用户端的换购页面'
      }else{
        this.title = '选择商品'
        this.subhead = ''
      }
    }
    private selectionchange(list){
      // console.log(list)
      this.chooselist = list
    }
    private save(){
      if(this.maxchoose>0&&this.chooselist&&this.chooselist.length>this.maxchoose){
        this.$message.error(`最多添加${this.maxchoose}件商品`)
        return 
      }
      this.pageNo = 1
      this.$emit('getshop',this.chooselist)
    }
    private cancel(){
      this.pageNo = 1
      this.$emit('close')
    }
    private changePage(e){
      this.pageNo = e
      this.gettablelist()
    }
    private doSearch(){
      this.pageNo = 1
      this.gettablelist()
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let data:any = {
					Skip: (this.pageNo-1)*this.pageSize,
					Take: this.pageSize,
					Keywords: this.keywords,
					ProductCategoryId: this.classify,
          ProductScheduleState:this.ProductScheduleState,
          ProductType:this.ProductType,
          IsExchangeBuyProduct:this.IsExchangeBuyProduct,
				}
        if (this.filterTime){
					var splitList = this.filterTime.split('/');
					data.StartTime = splitList[0];
					data.EndTime = splitList[1] ? (nextDay(splitList[1],1)) : '';
				}
        let res = await productpopoverproductlist(data)
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
          if(!this.dialogshow||!this.isfirst) return
          this.$nextTick(()=>{
                  // (this as any).$refs.table.clearSelection();
              // this.tablelist.map(x=>{
                this.chooselist.map(v=>{
                    // if(x.Id==v.Id){
                    // console.log(v);
                      (this as any).$refs.table.toggleRowSelection(v,true);
                    // }
                })
              // })
              this.gettablelist()
            this.isfirst = false
          })
        }
      }finally{
        this.tableloading = false
      }
    }
    private async getclassifylist() {
			let data: any = {
				Skip: 0,
				Take: 99999,
				Keywords: ''
			}
			try {
				const res: any = await productCategory(data);
        if(res.IsSuccess){
          this.classifylist = res.Result.Results.map(v=>{
            return {
              value:v.Id,
              label:v.CategoryName
            }
          })
        }
			} finally{
        //
      }
		}
  }
